// extracted by mini-css-extract-plugin
export default {"wrapper":"sx-z","button":"tx-z","alternate":"ux-z","disabled":"vx-z","paymentWarning":"wx-z","fadeIn":"xx-z"};